import { useFilterOptionsBase, BaseFilterOptionsResponse } from './useFilterOptionsBase';

/**
 * Hook for fetching worklog filter options.
 * Returns available users, projects, and admin status for the WorkLog page.
 */
export const useWorkLogFilterOptions = () => {
  const result = useFilterOptionsBase<BaseFilterOptionsResponse>('/workLogs/filterOptions');

  return {
    availableUsers: result.availableUsers,
    availableProjects: result.availableProjects,
    isAdmin: result.isAdmin,
    loading: result.loading,
    error: result.error,
    refresh: result.refresh,
  };
};
